/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Answer_CitationsInputs */

const en_faq_answer_citations = /** @type {(inputs: Faq_Answer_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, we skip those, so you can focus on the core material.`)
};

const es_faq_answer_citations = /** @type {(inputs: Faq_Answer_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, las omitimos para que puedas concentrarte en el material principal.`)
};

/**
* | output |
* | --- |
* | "Yes, we skip those, so you can focus on the core material." |
*
* @param {Faq_Answer_CitationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_answer_citations = /** @type {((inputs?: Faq_Answer_CitationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Answer_CitationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_answer_citations(inputs)
	return en_faq_answer_citations(inputs)
});